(function () {
  /** miot is initialized inside the Template  **/
  if (typeof miot !== 'undefined') {
    //region: Block.html

    // The comparison panel drives the tiles: the newest year is always the top band, and each
    // ticked year adds a band below it. A band's percentage is measured against the band directly
    // beneath it - the next older year - so the oldest band never shows one. Values for every
    // year/category pair are already in the DOM as <data> elements, so no round trip is needed.

    const panel = document.querySelector('.statCompare__panel');

    if (panel) {
      const maxBands = parseInt(panel.dataset.maxBands, 10) || 3;
      const maxCompare = Math.max(0, maxBands - 1);
      const checkboxes = Array.from(
        panel.querySelectorAll('.statCompare__checkbox'),
      );
      const chipList = panel.querySelector('.statCompare__chips');

      // Which categories add up to the total is an editor decision (the "main cargo" flag on the
      // category record), not a fixed list of uids.
      const raw = $('#mainCargoCategories').data('categories');
      const sumCategories =
        raw === undefined || raw === null || raw === ''
          ? []
          : raw
              .toString()
              .split(',')
              .map((uid) => parseInt(uid, 10));

      function readValue(yearUid, categoryUid) {
        const el = document.querySelector(
          'data.dataContainer.year' + yearUid + '.category' + categoryUid,
        );
        return el ? parseFloat(el.dataset.value) : null;
      }

      function sumFor(yearUid) {
        let total = 0;
        let found = false;
        sumCategories.forEach(function (categoryUid) {
          const v = readValue(yearUid, categoryUid);
          if (v !== null && !isNaN(v)) {
            total += v;
            found = true;
          }
        });
        return found ? total : null;
      }

      // Mirrors TileFactory::formatValue - German separators, trailing zeros trimmed.
      function formatValue(value, decimals) {
        let out = value.toLocaleString('de-DE', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        });
        if (out.indexOf(',') !== -1)
          out = out.replace(/0+$/, '').replace(/,$/, '');
        return out;
      }

      function selectedYears() {
        return checkboxes
          .filter((cb) => cb.checked)
          .map((cb) => ({
            uid: parseInt(cb.dataset.yearUid, 10),
            title: cb.dataset.yearTitle,
          }))
          .sort((a, b) => b.title.localeCompare(a.title));
      }

      function renderChips(years) {
        chipList.innerHTML = '';
        chipList.hidden = years.length === 0;
        years.forEach(function (year) {
          const li = document.createElement('li');
          li.className = 'statCompare__chip';
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.yearUid = year.uid;
          button.setAttribute(
            'aria-label',
            (translate('statistic.removeYear') || 'Jahr entfernen') +
              ' ' +
              year.title,
          );
          button.innerHTML =
            year.title + ' <span aria-hidden="true">\u00d7</span>';
          li.appendChild(button);
          chipList.appendChild(li);
        });
      }

      function renderTile(tile, years) {
        const template = tile.querySelector('.statTile__bandTemplate');
        const bands = tile.querySelector('.statTile__bands');
        const base = tile.querySelector('.statTile__head .statTile__band');
        if (!template || !bands || !base) return;

        const categoryUid = tile.dataset.category;
        const decimals = parseInt(tile.dataset.decimals, 10) || 0;
        const isSum = categoryUid === 'sum';

        // The headline band is server rendered inside the head and stays put; the comparison
        // container below it is ours to redraw.
        while (bands.firstChild) bands.removeChild(bands.firstChild);

        const rows = [
          {
            el: base,
            value: isSum
              ? sumFor(parseInt(base.dataset.yearUid, 10))
              : readValue(base.dataset.yearUid, categoryUid),
          },
        ];

        years.forEach(function (year, i) {
          const value = isSum
            ? sumFor(year.uid)
            : readValue(year.uid, categoryUid);
          if (value === null || isNaN(value)) return;

          const band = template.content.firstElementChild.cloneNode(true);
          band.className = 'statTile__band statTile__band--' + (i + 1);
          band.dataset.yearUid = year.uid;
          band.querySelector('.statTile__value').textContent = formatValue(
            value,
            decimals,
          );
          band.querySelector('.statTile__bandYear').textContent = year.title;
          band.querySelector('.statTile__delta').textContent = '';
          bands.appendChild(band);
          rows.push({ el: band, value: value });
        });

        // Each band compares against the one below it; the oldest keeps an empty badge.
        rows.forEach(function (row, i) {
          const delta = row.el.querySelector('.statTile__delta');
          const below = rows[i + 1];
          delta.className = 'statTile__delta';
          if (!below || below.value === 0 || below.value === null) {
            delta.textContent = '';
            return;
          }
          const change =
            ((row.value - below.value) / Math.abs(below.value)) * 100;
          const rounded = Math.round(change * 10) / 10;
          delta.textContent =
            (rounded >= 0 ? '+' : '') +
            rounded.toFixed(1).replace('.', ',') +
            '%';
          delta.classList.add(
            'statTile__delta--' +
              (rounded > 0 ? 'up' : rounded < 0 ? 'down' : 'same'),
          );
        });
      }

      function render() {
        const years = selectedYears();
        renderChips(years);
        checkboxes.forEach(function (cb) {
          cb.disabled = !cb.checked && years.length >= maxCompare;
        });
        document
          .querySelectorAll('.blockStatistic .statTile')
          .forEach(function (tile) {
            renderTile(tile, years);
          });
      }

      checkboxes.forEach((cb) => cb.addEventListener('change', render));

      chipList.addEventListener('click', function (event) {
        const button = event.target.closest('button[data-year-uid]');
        if (!button) return;
        const cb = checkboxes.find(
          (c) => c.dataset.yearUid === button.dataset.yearUid,
        );
        if (cb) {
          cb.checked = false;
          render();
        }
      });

      render();
    }
    //endregion;

    var limitSlider = document.getElementById('slider-limit');
    var years = [];

    $('.yearContainer').each(function () {
      years.push({
        title: $(this).data('year'),
        uid: $(this).data('uid'),
        active: true,
      });
    });

    if (limitSlider) {
      noUiSlider.create(limitSlider, {
        start: [years.length - 5, years.length],
        step: 1,
        tooltips: true,
        format: {
          to: function (value) {
            return years[parseInt(value) - 1].title;
          },
          from: function (value) {
            return value;
          },
        },
        connect: true,
        range: {
          min: 1,
          max: years.length,
        },
      });
      const limitHandles = limitSlider.querySelectorAll('.noUi-handle');
      limitHandles[0].setAttribute(
        'aria-label',
        translate('statistic.startYear'),
      );
      limitHandles[1].setAttribute(
        'aria-label',
        translate('statistic.endYear'),
      );
      limitSlider.noUiSlider.on('update', function (e) {
        let startYear = e[0];
        let endYear = e[1];
        let yearActive = false;
        for (var i = 0; i < years.length; i++) {
          if (years[i].title == startYear) yearActive = true;
          years[i].active = yearActive;
          if (years[i].title == endYear) yearActive = false;
        }

        data = {};
        $('input.categorySelector').each(function () {
          let $element = $(this);
          let subCategoryUid = $element.data('category');
          data[subCategoryUid] = parseData($element, subCategoryUid);
        });
        updateChart();
      });
    }

    if ($('#chart').length > 0) {
      const categories = $('#chart')
        .attr('data-category')
        .split(',')
        .map((cat) => 'data' + cat);
    } else {
      const categories = null;
    }

    const type = $('#chart').attr('data-chart-type');

    const barChartOptions = {
      data: {
        x: 'x',
        columns: [],
        type: 'bar',
        colors: {
          main: '#0B5FA1',
          sub: '#ABC8E0',
        },
      },
      tooltip: {
        format: {
          value: function (value) {
            return value + ' ' + miot;
          },
        },
      },
      grid: {
        width: 50,
        y: {
          show: true,
        },
        focus: {
          show: false,
        },
      },
      axis: {
        y: {
          label: {
            text: miot,
            position: 'inner-top',
            backgroundColor: '#0B5FA1',
          },
          tick: {
            outer: false,
            format: function (value) {
              return value.toLocaleString('de-DE');
            },
          },
        },
        x: {
          type: 'categories',
          tick: {
            centered: true,
            rotate: -90,
            multiline: false,
            outer: false,
          },
        },
      },
      bar: {
        width: { ratio: 0.7 },
        space: 0.4,
      },
      padding: {
        left: 75,
        top: 55,
      },
    };

    const donutChartOptions = {
      data: {
        columns: [],
        colors: {
          data1: '#EEF3F7',
          data2: '#ABC8E0',
          data3: '#0B5FA1',
          data4: '#7EA9D0',
        },
        type: 'donut',
        onclick: function (d, i) {
          console.log('onclick', d, i);
        },
        onmouseover: function (d, i) {
          console.log('onmouseover', d, i);
        },
        onmouseout: function (d, i) {
          console.log('onmouseout', d, i);
        },
      },
      tooltip: {
        format: {
          value: function (value) {
            return value + ' ' + miot;
          },
        },
      },
      legend: {
        position: 'right',
      },
      donut: {
        label: {
          format: function (value) {
            return value + ' ' + miot;
          },
        },
        multiline: true,
        expand: false,
      },
    };

    if ($(window).width() <= 768) {
      donutChartOptions.legend.position = 'bottom';
    }

    let chart;
    switch (type) {
      case 'bar':
        chart = c3.generate(barChartOptions);
        break;
      case 'donut':
        chart = c3.generate(donutChartOptions);
        break;
    }
    const columns = [['x', []]];
    const names = {};

    function parseData($checkbox, subCategoryUid) {
      let colx = ['x'];
      let colsub = ['sub'];
      let colmain = ['main'];
      for (var i = 0; i < years.length; i++) {
        let uid = years[i].uid;

        if (years[i].active) {
          colx.push(years[i].title);
          colmain.push(
            parseFloat(
              $('.dataContainer.defaultCategory.year' + uid).data('value'),
            ),
          );
          if (subCategoryUid)
            colsub.push(
              parseFloat(
                $(
                  '.dataContainer.category' + subCategoryUid + '.year' + uid,
                ).data('value'),
              ),
            );
        }
      }

      if (!subCategoryUid) {
        return {
          columns: [colx, colmain],
          names: { main: $('#chart').data('title') },
        };
      }

      return {
        columns: [colx, colsub, colmain],
        names: {
          sub: $checkbox.data('title'),
          main: $('#chart').data('title'),
        },
      };
    }

    let data = {};
    $('input.categorySelector').each(function () {
      let $element = $(this);
      let subCategoryUid = $element.data('category');
      data[subCategoryUid] = parseData($element, subCategoryUid);
    });

    function updateChart() {
      let subCategoryUid = $('input.categorySelector:checked').data('category');
      if (subCategoryUid) {
        $('#categoryMobile' + subCategoryUid).prop('checked', true);
        let loadOptions = data[subCategoryUid];
        if (chart) chart.load(loadOptions);
      } else if (type === 'bar' && $('input.categorySelector').length === 0) {
        if (chart) chart.load(parseData(null, null));
      }
    }
    updateChart();

    function updateMobileSelector() {
      let subCategoryUid = $('input.categoryMobileSelector:checked').data(
        'category',
      );
      $('#category' + subCategoryUid).prop('checked', true);
      $('#category' + subCategoryUid).trigger('change');
    }

    $('.categorySelector').change(updateChart);
    $('.categoryMobileSelector').change(updateMobileSelector);

    $.get(
      ($('html').attr('lang') != 'de-de' ? '/en' : '') +
        '/jsonAction/statistik',
      function (data) {
        let categories = null;
        if ($('#chart').length > 0) {
          categories = $('#chart')
            .attr('data-category')
            .split(',')
            .map((cat) => 'data' + cat);
        }
        let subCategory =
          'data' + $('input.categorySelector:checked').data('category');

        switch (type) {
          case 'bar': {
            // const columns = [['x', ...data['years']]];
            // const names = {};
            // Object.keys(data).forEach(key => {
            //     if (key !== 'names' && key !== 'years' && (categories.indexOf(key) !== -1)) {
            //         columns.push(['main', ...data[key]]);
            //         names['main'] = data['names'][key];
            //     }
            //     if (key !== 'names' && key !== 'years' && (key == subCategory)) {
            //         columns.push(['sub', ...data[key]]);
            //         names['sub'] = data['names'][key];
            //     }
            // })
            // const loadOptions = {
            //     columns,
            //     names
            // }
            // console.log(JSON.stringify(loadOptions));
            // chart.load(loadOptions);
            break;
          }
          case 'donut': {
            verticalSliderData = data;
            const years = data['years'];

            // The newest year on the axis is not necessarily the newest year with numbers behind
            // it for the categories on this element. Loading a column of nulls leaves c3 with an
            // empty donut, which is what "chart only shows up after an action" was.
            let indexLastYear = -1;
            for (let i = years.length - 1; i >= 0; i--) {
              const hasValue = (categories || []).some(function (key) {
                return (
                  data[key] &&
                  data[key][i] !== null &&
                  data[key][i] !== undefined
                );
              });
              if (hasValue) {
                indexLastYear = i;
                break;
              }
            }
            if (indexLastYear === -1) break;

            const columns = [];
            const names = {};
            Object.keys(data).forEach((key) => {
              console.log(categories);
              if (
                key !== 'names' &&
                key !== 'years' &&
                categories.indexOf(key) !== -1
              ) {
                columns.push([key, data[key][indexLastYear]]);
                names[key] = data['names'][key];
              }
            });
            const loadOptions = {
              columns,
              names,
            };
            console.log(loadOptions);
            chart.load(loadOptions);
            d3.select('#chart .c3-chart-arcs-title').node().innerHTML =
              years[indexLastYear].toString();
            break;
          }
        }
      },
    );

    var verticalSlider = document.getElementById('slider-vertical');
    var verticalSliderData = false;
    // min and max are both year positions, so a single year would collapse the range and
    // noUiSlider refuses to build it.
    if (verticalSlider && years.length > 1) {
      noUiSlider.create(verticalSlider, {
        start: 1,
        step: 1,
        connect: [false, true],
        tooltips: true,
        orientation: 'vertical',
        behaviour: 'drag',
        format: {
          to: function (value) {
            return years[parseInt(value) - 1].title;
          },
          from: function (value) {
            return value;
          },
        },
        range: {
          min: 1,
          max: years.length,
        },
      });
      verticalSlider
        .querySelector('.noUi-handle')
        .setAttribute('aria-label', translate('statistic.year'));
      verticalSlider.noUiSlider.on('update', function (e) {
        if (verticalSliderData) {
          var year = e[0];
          let categories = null;
          if ($('#chart').length > 0) {
            categories = $('#chart')
              .attr('data-category')
              .split(',')
              .map((cat) => 'data' + cat);
          }
          const years = verticalSliderData['years'];
          const indexLastYear = years.indexOf(year.toString());
          const columns = [];
          const names = {};
          Object.keys(verticalSliderData).forEach((key) => {
            if (
              key !== 'names' &&
              key !== 'years' &&
              categories.indexOf(key) !== -1
            ) {
              columns.push([key, verticalSliderData[key][indexLastYear]]);
              names[key] = verticalSliderData['names'][key];
            }
          });
          const loadOptions = {
            columns,
            names,
          };
          chart.load(loadOptions);
          d3.select('#chart .c3-chart-arcs-title').node().innerHTML =
            year.toString();
        }
      });
    }
  }
})();
